import { createSlice, createSelector } from '@reduxjs/toolkit';
import { getHomepage } from 'api/Homepage';
import { fetchWithLanguage } from 'store/helpers';

export const fetchHomepage = fetchWithLanguage('fetchHomepage', getHomepage);

const homepageSlice = createSlice({
    name: 'homepageSlice',
    initialState: {
        homepage: {},
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchHomepage.fulfilled, (state, action) => {
            state.homepage = action.payload;
        });
    },
});

export const selectHomepage = createSelector([state => state.homepageState.homepage], homepage => homepage.data || {});

export default homepageSlice.reducer;
